import type { StepIconProps } from '@mui/material/StepIcon'

import { Box, Typography } from '@mui/material'

import { RadioImage } from '@/components/ui/radio-image'

export function StepIcon({ active, completed, icon }: StepIconProps) {
  if (completed) {
    return <RadioImage checked width={24} height={24} />
  }

  return (
    <Box
      sx={{
        width: 24,
        height: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        bgcolor: active ? undefined : 'grey.200',
        background: active ? 'linear-gradient(180deg, #4C27FF 0%, #877FFF 100%)' : undefined,
      }}
    >
      <Typography variant="body2" sx={{ color: 'primary.contrastText', fontWeight: 600 }}>
        {icon}
      </Typography>
    </Box>
  )
}
